<template>
  <uikit-drawer id="drawer-ad-agency-contact">
    <template #header>
      <div class="agency">
        <img
          v-if="hasAgencyPhoto"
          width="48"
          height="48"
          class="logo"
          :alt="`Logo de ${agencyName}`"
          :src="agencyLogoUrl"
        />
        <div class="metas">
          <div class="name">
            {{ agencyName }}
          </div>
        </div>
      </div>
    </template>

    <div class="separator" />

    <uikit-form-row one-column>
      <uikit-form-cell title="Email" required>
        <uikit-input-new id="email" name="email" placeholder="Votre adresse email" />
      </uikit-form-cell>
    </uikit-form-row>

    <template #footer>
      <uikit-button
        class="u-w-full"
        type="primary"
        :loading="isSubmitting"
        :disabled="isSubmitting"
        @click="handleSubmitForm"
      >
        Être recontacté(e)
      </uikit-button>
    </template>
  </uikit-drawer>
</template>

<script setup>
import {
  UikitButton,
  UikitDrawer,
  UikitFormCell,
  UikitFormRow,
  UikitInputNew,
  useDrawerStore,
} from '@hz/ui-kit'

import { useForm } from 'vee-validate'

const props = defineProps({
  onSuccess: {
    type: Function,
    required: true,
  },
  handleSubmitContactForm: {
    type: Function,
    required: true,
  },
  agencyName: {
    type: String,
    required: true,
  },
  agencyLogoUrl: {
    type: String,
    default: null,
  },
})

const attrs = useAttrs()
const config = useRuntimeConfig()

const hasAgencyPhoto = computed(() => !!props.agencyLogoUrl)

const validationSchema = {
  email: { email: true, required: true },
}

const { handleSubmit, isSubmitting } = useForm({
  validationSchema,
})

const close = () => {
  useDrawerStore().removeDrawer({ id: attrs.id })
}

const handleSubmitForm = handleSubmit(async (values) => {
  grecaptcha.enterprise.ready(async () => {
    const token = await grecaptcha.enterprise.execute(config.public.adReCaptchaSiteKey, { action: 'LOGIN' })
    props.handleSubmitContactForm({
      reCaptchaToken: token,
      email: values.email,
    })

    props.onSuccess()
    close()
  })
})
</script>

<style lang="less" scoped>
.agency {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: flex-start;
  gap: 18px;

  .logo {
    align-self: flex-start;
    width: 48px;
    height: 48px;
    border-radius: 50%;
  }
  .metas {
    display: flex;
    flex-direction: column;
  }
  .name {
    font-size: 18px;
    font-weight: var(--ds-weight-semi-bold);
  }
}

.separator {
  width: 100%;
  height: 1px;
  background-color: var(--ds-color-gray-25);
  margin-bottom: 32px;
}

:deep(.drawer-header) {
  padding: 24px;
}

:deep(.drawer-body) {
  padding-top: 0;
}
</style>
